import type { IconProps } from './IconProps';

export const FarcasterIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      d="M3.64062 1.7998H12.3606V14.1998H11.0806V8.5198H11.0681C10.9266 6.94998 9.60726 5.71979 8.00062 5.71979C6.39398 5.71979 5.07465 6.94998 4.93317 8.5198H4.92062V14.1998H3.64062V1.7998Z"
      fill="currentColor"
    />
    <path
      d="M1.32031 3.56006L1.84031 5.32006H2.28031V12.4401C2.05939 12.4401 1.88031 12.6192 1.88031 12.8401V13.3201H1.80032C1.5794 13.3201 1.4003 13.4992 1.4003 13.7201V14.2001H5.88031V13.7201C5.88031 13.4992 5.70122 13.3201 5.48031 13.3201H5.40032V12.8401C5.40032 12.6192 5.22122 12.4401 5.0003 12.4401H4.52032V3.56006H1.32031Z"
      fill="currentColor"
    />
    <path
      d="M11.1613 12.4401C10.9403 12.4401 10.7612 12.6192 10.7612 12.8401V13.3201H10.6812C10.4603 13.3201 10.2812 13.4992 10.2812 13.7201V14.2001H14.7613V13.7201C14.7613 13.4992 14.5822 13.3201 14.3612 13.3201H14.2812V12.8401C14.2812 12.6192 14.1022 12.4401 13.8813 12.4401V5.32006H14.3212L14.8412 3.56006H11.6412V12.4401H11.1613Z"
      fill="currentColor"
    />
  </svg>
);
